var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_7151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 3.58172 7.58172 0 12 0C16.4183 0 20 3.58172 20 8V24H4V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.99854,
    y1: 6.75012,
    x2: 16.0005,
    y2: 6.75012,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.752 17.5001V14.7561H10.212V16.1761L11.248 14.7561H11.756L10.94 15.8681L11.784 17.5001H11.268L10.644 16.2361L10.212 16.7481V17.5001H9.752ZM12.0326 17.5001V14.7561H12.6886L13.0806 16.3681C13.0913 16.4135 13.1019 16.4708 13.1126 16.5401C13.1259 16.6095 13.1379 16.6788 13.1486 16.7481C13.1593 16.8148 13.1673 16.8708 13.1726 16.9161C13.1779 16.9615 13.1806 16.9841 13.1806 16.9841H13.1966C13.1966 16.9841 13.1993 16.9615 13.2046 16.9161C13.2126 16.8681 13.2206 16.8095 13.2286 16.7401C13.2366 16.6708 13.2459 16.6028 13.2566 16.5361C13.2673 16.4668 13.2779 16.4108 13.2886 16.3681L13.6766 14.7561H14.3166V17.5001H13.8846V15.6681C13.8846 15.6388 13.8859 15.6001 13.8886 15.5521C13.8913 15.5041 13.8939 15.4561 13.8966 15.4081C13.8993 15.3601 13.9019 15.3188 13.9046 15.2841C13.9073 15.2495 13.9086 15.2321 13.9086 15.2321H13.8926C13.8873 15.2561 13.8806 15.2868 13.8726 15.3241C13.8646 15.3588 13.8566 15.3961 13.8486 15.4361C13.8406 15.4761 13.8313 15.5161 13.8206 15.5561C13.8126 15.5961 13.8046 15.6321 13.7966 15.6641L13.3566 17.5001H12.9566L12.5126 15.6561C12.5073 15.6295 12.4993 15.5961 12.4886 15.5561C12.4806 15.5161 12.4726 15.4761 12.4646 15.4361C12.4566 15.3961 12.4486 15.3588 12.4406 15.3241C12.4326 15.2868 12.4259 15.2561 12.4206 15.2321H12.4046C12.4046 15.2321 12.4059 15.2508 12.4086 15.2881C12.4113 15.3228 12.4139 15.3655 12.4166 15.4161C12.4193 15.4641 12.4219 15.5121 12.4246 15.5601C12.4273 15.6081 12.4286 15.6441 12.4286 15.6681V17.5001H12.0326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2031_7151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 7C4 3.13401 7.13401 0 11 0H13C16.866 0 20 3.13401 20 7H4Z",
    fill: "#F59741"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.99854,
    y1: 6.75012,
    x2: 16.0005,
    y2: 6.75012,
    stroke: "black",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.25454 6.75C4.38606 3.1379 7.35578 0.25 11 0.25H13C16.6442 0.25 19.6139 3.1379 19.7455 6.75H4.25454Z",
    stroke: "#1D2939",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 8C4.25 3.71979 7.71979 0.25 12 0.25C16.2802 0.25 19.75 3.71979 19.75 8V23.75H4.25V8Z",
    stroke: "#1D2939",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_7151"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 3.58172 7.58172 0 12 0C16.4183 0 20 3.58172 20 8V24H4V8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2031_7151"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 7C4 3.13401 7.13401 0 11 0H13C16.866 0 20 3.13401 20 7H4Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.108b7a69e38f80c4565cd7172cd84154.svg";
export { ForwardRef as ReactComponent };